import { render, staticRenderFns } from "./nimei-program-detail.vue?vue&type=template&id=5901edf2"
import script from "./nimei-program-detail.vue?vue&type=script&lang=js"
export * from "./nimei-program-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports